module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('md-whiteframe', {
    staticClass: "camera-toolbar",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-dense"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.activeItem.name))])]), _vm._v(" "), _c('span', {
    staticClass: "equipment-description"
  }, [_vm._v(_vm._s(_vm.activeItem.description))])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('span', {
    staticClass: "md-subheading photo-title"
  }, [_vm._v("Fotografe os focos solicitados abaixo")]), _vm._v(" "), _c('md-stepper', {
    attrs: {
      "md-vertical": "",
      "md-alternate-labels": ""
    },
    on: {
      "completed": _vm.onCompleted
    }
  }, _vm._l((_vm.activeItem.photos), function(photo, key) {
    return _c('md-step', {
      key: photo['.key'],
      attrs: {
        "md-active": key <= 0,
        "photoId": key,
        "md-label": photo.name,
        "md-continue": photo.image !== '' && photo.image !== null && photo.image !== undefined,
        "md-message": photo.description,
        "md-button-continue": _vm.continueButton,
        "md-button-back": "ANTERIOR",
        "md-editable": true
      }
    }, [_c('camera-image-select', {
      ref: "cameraImageSelect",
      refInFor: true,
      attrs: {
        "photoId": key,
        "description": photo.description,
        "imageId": photo.image,
        "imageUrl": photo.url
      },
      on: {
        "add": _vm.addPhoto,
        "select": _vm.previewImage
      }
    })], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3289a174","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CameraView.vue
// module id = 827
// module chunks = 1